<template>
  <div>
    <div class="container">
      <datatable
          :url="usersUrl"
          :columns="tColumns"
          :options="tOptions"
          @checked="onChecked">

          <template slot="status" slot-scope="props">
            <!-- Here we call a method on click and we pass a row data from the slot's properties -->
            <button class="btn btn-sm" v-bind:class="{ 'btn-info': props.row.status === UserStatus.ACTIVE, 'btn-danger': props.row.status === UserStatus.REVOKED }">{{$t('userAdministration.userStatuses.' + props.row.status)}}</button>
          </template>
      </datatable>

      <div slot="footer" class="text-right" v-if="optionsVisible">
        <b-btn variant="success" v-on:click="revokeUsers()" :disabled="load">
          {{ $t('userAdministration.userRevoke') }}
          <loader :show="load" type="button"></loader>
        </b-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import Datatable from '@/components/misc/datatable/Datatable'
  import { EventBus } from '@/router/bus'
  import i18n from '@/i18n'
  import Loader from '@/components/misc/Loader'

  export default {
    name: 'local-user-management',
    components: {
      Datatable,
      Loader
    },
    data () {
      return {
        load: false,
        UserStatus: {
          ACTIVE: 1,
          INACTIVE: 2,
          REVOKED: 3,
          DISABLED: 4
        },
        tOptions: {
          checkboxValue: 'userId',
          payloadsTotalPropertyName: 'additionalInformation',
          invalidRowMarker: {
            criteria: function (row, statuses) {
              return row['status'] !== statuses.ACTIVE
            }
          },
          detailsLink: {
            createLink: function (row) {
              return 'user-administration/local-user/' + row['userId']
            }
          }
        },
        tColumns: [
          {
            columnName: 'name',
            title: i18n.t('userAdministration.userName'),
            filterType: 'input',
            cell (row) {
              return row.name
            }
          },
          {
            columnName: 'login',
            title: i18n.t('userAdministration.userLogin'),
            filterType: 'input',
            align: 'center',
            cell (row) {
              return row.login
            }
          },
          {
            columnName: 'email',
            title: i18n.t('userAdministration.userEmail'),
            filterType: 'input',
            align: 'center',
            cell (row) {
              return row.email
            }
          },
          {
            columnName: 'status',
            title: i18n.t('userAdministration.userStatus'),
            hideSort: true,
            align: 'center',
            filterType: 'select',
            filterSelectOptions: [
              { key: i18n.t('userAdministration.userStatuses.0'), value: '' },
              { key: i18n.t('userAdministration.userStatuses.1'), value: 1 },
              { key: i18n.t('userAdministration.userStatuses.2'), value: 2 },
              { key: i18n.t('userAdministration.userStatuses.3'), value: 3 },
              { key: i18n.t('userAdministration.userStatuses.4'), value: 4 }
            ],
            cell (row) {
              return null
            }
          }
        ],
        usersUrl: '',
        selectedUsers: [],
        optionsVisible: false
      }
    },
    created: function () {
      this.usersUrl = Vue.$apiConfig.pagedLocalUsersInformationGet
      this.tOptions.statuses = this.UserStatus
    },
    methods: {
      onChecked (checkedValues) {
        this.selectedUsers = checkedValues
        this.optionsVisible = checkedValues.length > 0
      },
      revokeUsers () {
        this.logConsole('Revoking users ' + this.selectedUSers)
        this.load = true
        let request = []
        for (var i = 0; i < this.selectedUsers.length; i++) {
          let user = {}
          user.userId = Number(this.selectedUsers[i])
          request.push(user)
        }

        this.$http.post(Vue.$apiConfig.userRevokePost, request)
          .then(response => {
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.userRevoked'),
              errors: []
            })
            EventBus.$emit('refresh-table')
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>

  .container {
    padding: 0px;
  }

  @media (min-width: 1400px) {
      .container {
          width: 1360px;
          max-width: 100%;
      }
  }

  @media (min-width: 1680px) {
      .container {
          width: 1640px;
          max-width: 100%;
      }
  }

  @media (min-width: 1920px) {
      .container {
          width: 1860px;
          max-width: 100%;
      }
  }
  
  @media (min-width: 2560px) {
      .container {
          width: 2460px;
          max-width: 100%;
      }
  }

  @media (min-width: 2880px) {
      .container {
          width: 2620px;
          max-width: 100%;
      }
  }

  @media (min-width: 3840px) {
      .container {
          width: 3550px;
          max-width: 100%;
      }
  }    
    
</style>




// WEBPACK FOOTER //
// LocalUserManagement.vue?9fa126e6